import { autobind } from 'core-decorators';
import { Component } from 'react';
import Metrics from '/@/components/metrics';
import { _, _lazy } from '/@/locale';

@autobind
export default class NutritionalInfo extends Component {
    static label = _lazy('Información nutricional');
    static icon = 'corn';

    render() {
        const { brand, productRecommendations, country } = this.props;

        const profiles = productRecommendations.map((recommendation) => {
            return {
                ...recommendation.profile,
                features: recommendation.profile.nutritionalInfo || [],
            };
        });

        return (
            <Metrics
                title={_('Información nutricional')}
                dataKey='features'
                products={profiles}
                brand={brand}
                country={country}
            />
        );
    }
}
